import { trigger, transition, style, animate } from '@angular/animations';

export const slideDownUpTrigger = trigger('slideDownUpTrigger', [
  transition(':enter', [style({ height: 0 }), animate('100ms', style({ height: '*' }))]),
  transition(':leave', [animate('100ms', style({ height: 0 }))])
]);
